import type { Axios } from 'axios'

import type { GivingCampaignOverviewDto } from '../campaign.types'
import { toGsResponse, type GsResponse, type RawResponse } from '../../goodstack'

import type { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'

export const cancelCampaign: MutationFn<[string], GsResponse<GivingCampaignOverviewDto>> = async (
  client: Axios,
  [campaignId]
) => {
  const response = await client.delete<RawResponse<GivingCampaignOverviewDto>>(`v1/giving-campaign/${campaignId}`, {
    withCredentials: true,
    validateStatus: status => status === 200 || status === 400
  })

  return toGsResponse(response.status, response.data)
}
